import { Portal } from "../Portal/index.js";
import { Snackbar } from "../Snackbar/index.js";
import "./Snackbar.toast.css";
import { jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import { ToastContainer, cssTransition, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//#region src/SnackbarCenter/index.tsx
const SNACKBAR_CONTAINER_ID = "snackbar";
const SNACKBAR_CONTAINER_MARKER = "data-snackbar-center";
const snackTransition = cssTransition({
	enter: "snack-in",
	exit: "snack-out"
});
let defaultSnackbarDuration = 3e3;
let lazySnackbarRoot = null;
const SnackbarToastContainer = ({ position }) => /* @__PURE__ */ jsx(ToastContainer, {
	containerId: SNACKBAR_CONTAINER_ID,
	draggable: false,
	closeOnClick: false,
	hideProgressBar: true,
	autoClose: false,
	newestOnTop: true,
	position,
	transition: snackTransition,
	toastStyle: {
		padding: 0,
		margin: 0,
		background: "transparent",
		boxShadow: "none",
		width: "30rem",
		maxWidth: "calc(100vw - 2rem)"
	},
	style: {
		width: "30rem",
		maxWidth: "calc(100vw - 2rem)"
	},
	limit: 5
});
const ensureSnackbarCenter = () => {
	if (typeof document === "undefined") return;
	if (document.querySelector(`[${SNACKBAR_CONTAINER_MARKER}="${SNACKBAR_CONTAINER_ID}"]`) || lazySnackbarRoot) return;
	const container = document.createElement("div");
	container.setAttribute(SNACKBAR_CONTAINER_MARKER, SNACKBAR_CONTAINER_ID);
	container.setAttribute("data-snackbar-lazy", "true");
	document.body.append(container);
	lazySnackbarRoot = createRoot(container);
	lazySnackbarRoot.render(/* @__PURE__ */ jsx(SnackbarToastContainer, { position: "bottom-center" }));
};
const SnackbarCenter = ({ duration = 3e3, position = "bottom-center" }) => {
	defaultSnackbarDuration = duration;
	if (typeof document !== "undefined" && lazySnackbarRoot) return null;
	return /* @__PURE__ */ jsx(Portal, { children: /* @__PURE__ */ jsx("div", {
		"data-snackbar-center": SNACKBAR_CONTAINER_ID,
		children: /* @__PURE__ */ jsx(SnackbarToastContainer, { position })
	}) });
};
const renderSnackbar = (options) => function SnackbarToast({ closeToast }) {
	return /* @__PURE__ */ jsx(Snackbar, {
		...options,
		closeToast,
		duration: options.duration ?? defaultSnackbarDuration
	});
};
/**
* Показ обычного snackbar-уведомления.
*/
const setSnack = (options) => {
	ensureSnackbarCenter();
	return toast(renderSnackbar(options), {
		containerId: SNACKBAR_CONTAINER_ID,
		autoClose: false,
		position: "bottom-center"
	});
};
const removeSnack = (toastId) => {
	toast.dismiss(toastId);
};
/**
* Показ snackbar с отслеживанием Promise (pending / fulfilled / rejected).
*/
const setPromiseSnack = (options) => {
	ensureSnackbarCenter();
	return toast(renderSnackbar(options), {
		containerId: SNACKBAR_CONTAINER_ID,
		autoClose: false,
		position: "bottom-center"
	});
};
//#endregion
export { SnackbarCenter, removeSnack, setPromiseSnack, setSnack };

//# sourceMappingURL=index.js.map